import React from "react";

export const SenatHemicycleIcon = React.forwardRef((props: any, ref) => {
  return (
    <svg ref={ref} {...props} viewBox="0 0 655 322">
      <circle
        data-seat="1"
        cx="278.81"
        cy="230.35"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="2"
        cx="290.83"
        cy="223.29"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="3"
        cx="303.57"
        cy="218.11"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="4"
        cx="316.92"
        cy="214.95"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="5"
        cx="343.69"
        cy="214.95"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="6"
        cx="356.42"
        cy="217.98"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="7"
        cx="369.93"
        cy="223.18"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="8"
        cx="381.7"
        cy="230.35"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="9"
        cx="401.27"
        cy="248.68"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="10"
        cx="409.18"
        cy="261.37"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="11"
        cx="414.88"
        cy="274.66"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="12"
        cx="418.33"
        cy="288.87"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="13"
        cx="419.49"
        cy="303.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="14"
        cx="215.17"
        cy="316.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="15"
        cx="215.17"
        cy="301.51"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="16"
        cx="216.28"
        cy="286.09"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="17"
        cx="219.65"
        cy="271.09"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="18"
        cx="225.04"
        cy="256.3"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="19"
        cx="232.19"
        cy="242.74"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="20"
        cx="241.4"
        cy="229.9"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="21"
        cx="260.56"
        cy="211.43"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="22"
        cx="273.32"
        cy="202.9"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="23"
        cx="287.24"
        cy="196.16"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="24"
        cx="301.93"
        cy="191.38"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="25"
        cx="316.92"
        cy="188.72"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="26"
        cx="343.69"
        cy="188.72"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="27"
        cx="358.94"
        cy="191.39"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="28"
        cx="373.45"
        cy="196.15"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="29"
        cx="387.21"
        cy="202.84"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="30"
        cx="400.2"
        cy="211.44"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="31"
        cx="419.33"
        cy="229.87"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="32"
        cx="428.49"
        cy="242.69"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="33"
        cx="435.87"
        cy="256.74"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="34"
        cx="441.36"
        cy="272.14"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="35"
        cx="444.45"
        cy="287.17"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="36"
        cx="445.56"
        cy="303.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="37"
        cx="189.09"
        cy="316.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="38"
        cx="189.09"
        cy="303.11"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="39"
        cx="189.83"
        cy="288.88"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="40"
        cx="191.99"
        cy="274.66"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="41"
        cx="195.48"
        cy="260.74"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="42"
        cx="200.43"
        cy="247.58"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="43"
        cx="206.56"
        cy="235.06"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="44"
        cx="214.6"
        cy="222.18"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="45"
        cx="223.14"
        cy="211.11"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="46"
        cx="242.27"
        cy="192.69"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="47"
        cx="253.51"
        cy="184.57"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="48"
        cx="265.1"
        cy="177.78"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="49"
        cx="277.44"
        cy="172.1"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="50"
        cx="290.34"
        cy="167.6"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="51"
        cx="303.37"
        cy="164.44"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="52"
        cx="316.92"
        cy="162.49"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="53"
        cx="343.69"
        cy="162.49"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="54"
        cx="357.23"
        cy="164.55"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="55"
        cx="370.55"
        cy="167.56"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="56"
        cx="383.36"
        cy="172.17"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="57"
        cx="395.74"
        cy="177.9"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="58"
        cx="407.5"
        cy="184.9"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="59"
        cx="418.31"
        cy="192.53"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="60"
        cx="437.39"
        cy="211.13"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="61"
        cx="446.32"
        cy="222.59"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="62"
        cx="453.82"
        cy="234.65"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="63"
        cx="460.08"
        cy="247.4"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle data-seat="64" cx="465.12" cy="261" r="6" fill="#CFD8DC"></circle>
      <circle
        data-seat="65"
        cx="468.64"
        cy="274.65"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="66"
        cx="470.77"
        cy="288.71"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="67"
        cx="471.48"
        cy="303.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="68"
        cx="163.01"
        cy="316.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="69"
        cx="163.01"
        cy="302.87"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="70"
        cx="163.62"
        cy="288.48"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle data-seat="71" cx="165.51" cy="274" r="6" fill="#CFD8DC"></circle>
      <circle
        data-seat="72"
        cx="168.8"
        cy="259.35"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="73"
        cx="173.59"
        cy="244.57"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="74"
        cx="179.36"
        cy="230.83"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="75"
        cx="186.75"
        cy="217.09"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="76"
        cx="195.34"
        cy="204.68"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="77"
        cx="204.96"
        cy="192.22"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="78"
        cx="224.29"
        cy="173.78"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="79"
        cx="235.7"
        cy="165.02"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="80"
        cx="248.13"
        cy="157.41"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="81"
        cx="261.34"
        cy="150.61"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="82"
        cx="274.72"
        cy="145.22"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="83"
        cx="288.65"
        cy="141.02"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="84"
        cx="302.59"
        cy="138.03"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="85"
        cx="316.92"
        cy="136.26"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="86"
        cx="343.69"
        cy="136.26"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="87"
        cx="358.31"
        cy="138.03"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="88"
        cx="372.79"
        cy="141.23"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="89"
        cx="386.57"
        cy="145.38"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="90"
        cx="399.73"
        cy="150.61"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="91"
        cx="412.78"
        cy="157.36"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="92"
        cx="424.87"
        cy="164.86"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="93"
        cx="436.49"
        cy="173.78"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="94"
        cx="455.47"
        cy="191.73"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="95"
        cx="465.12"
        cy="203.13"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="96"
        cx="473.4"
        cy="215.99"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="97"
        cx="480.92"
        cy="229.48"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="98"
        cx="486.9"
        cy="243.57"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="99"
        cx="491.51"
        cy="258.12"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="100"
        cx="495.22"
        cy="273.2"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="101"
        cx="497.18"
        cy="288.14"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="102"
        cx="497.71"
        cy="303.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="103"
        cx="136.94"
        cy="316.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="104"
        cx="136.94"
        cy="303.12"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="105"
        cx="137.31"
        cy="289.91"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="106"
        cx="138.79"
        cy="276.67"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="107"
        cx="141.14"
        cy="263.13"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="108"
        cx="144.49"
        cy="249.78"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="109"
        cx="148.67"
        cy="236.82"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="110"
        cx="159.37"
        cy="212.38"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="111"
        cx="167.33"
        cy="198.54"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="112"
        cx="176.81"
        cy="185.45"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="113"
        cx="186.76"
        cy="173.49"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="114"
        cx="206.08"
        cy="154.78"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="115"
        cx="218.97"
        cy="144.97"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="116"
        cx="232.46"
        cy="136.25"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="117"
        cx="246.1"
        cy="128.81"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="118"
        cx="270.97"
        cy="118.92"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="119"
        cx="286.05"
        cy="114.78"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="120"
        cx="301.16"
        cy="111.77"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="121"
        cx="316.92"
        cy="110.03"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="122"
        cx="343.69"
        cy="110.03"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="123"
        cx="359.45"
        cy="111.67"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="124"
        cx="375.16"
        cy="114.64"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="125"
        cx="390.49"
        cy="119.07"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="126"
        cx="415.19"
        cy="129.12"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="127"
        cx="428.95"
        cy="136.62"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="128"
        cx="442.13"
        cy="145.38"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="129"
        cx="454.61"
        cy="154.85"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="130"
        cx="473.87"
        cy="173.29"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="131"
        cx="483.98"
        cy="185.72"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="132"
        cx="493.23"
        cy="198.69"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="133"
        cx="501.4"
        cy="212.77"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="134"
        cx="512.09"
        cy="236.82"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="135"
        cx="516.38"
        cy="249.71"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="136"
        cx="519.63"
        cy="262.84"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="137"
        cx="521.96"
        cy="275.97"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="138"
        cx="523.23"
        cy="289.47"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="139"
        cx="523.79"
        cy="303.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="140"
        cx="110.86"
        cy="316.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="141"
        cx="110.86"
        cy="301.14"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="142"
        cx="111.45"
        cy="286.45"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="143"
        cx="113.03"
        cy="271.34"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="144"
        cx="115.89"
        cy="256.05"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="145"
        cx="119.65"
        cy="241.33"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="146"
        cx="124.68"
        cy="226.14"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="147"
        cx="135.61"
        cy="201.61"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="148"
        cx="142.68"
        cy="189.14"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="149"
        cx="150.55"
        cy="177.1"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="150"
        cx="159.37"
        cy="165.45"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="151"
        cx="168.73"
        cy="154.64"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="152"
        cx="187.5"
        cy="136.26"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="153"
        cx="199.18"
        cy="127.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="154"
        cx="211.1"
        cy="118.87"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="155"
        cx="223.54"
        cy="111.18"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="156"
        cx="236.49"
        cy="104.68"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="157"
        cx="261.34"
        cy="94.73"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="158"
        cx="274.85"
        cy="90.67"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="159"
        cx="288.76"
        cy="87.47"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="160"
        cx="302.96"
        cy="85.31"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="161"
        cx="316.92"
        cy="83.98"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="162"
        cx="343.69"
        cy="83.8"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="163"
        cx="358.17"
        cy="85.31"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="164"
        cx="372.48"
        cy="87.54"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="165"
        cx="386.53"
        cy="90.67"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="166"
        cx="400.26"
        cy="94.95"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="167"
        cx="425.03"
        cy="104.95"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="168"
        cx="437.67"
        cy="111.4"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="169"
        cx="450"
        cy="119.09"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="170"
        cx="461.54"
        cy="126.97"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="171"
        cx="472.76"
        cy="136.1"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="172"
        cx="491.87"
        cy="154.53"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="173"
        cx="501.37"
        cy="165.46"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="174"
        cx="510.06"
        cy="176.89"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="175"
        cx="518.07"
        cy="189.06"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="176"
        cx="525.22"
        cy="201.91"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="177"
        cx="536.07"
        cy="225.95"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="178"
        cx="540.99"
        cy="240.82"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="179"
        cx="544.83"
        cy="255.84"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="180"
        cx="547.67"
        cy="271.51"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="181"
        cx="549.29"
        cy="287.17"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="182"
        cx="549.86"
        cy="303.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="183"
        cx="84.79"
        cy="316.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="184"
        cx="84.79"
        cy="301.64"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="185"
        cx="85.41"
        cy="286.93"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="186"
        cx="86.65"
        cy="272.27"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="187"
        cx="88.89"
        cy="258.2"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="188"
        cx="91.89"
        cy="244.13"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="189"
        cx="95.92"
        cy="229.86"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="190"
        cx="100.84"
        cy="215.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="191"
        cx="111.69"
        cy="191.16"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="192"
        cx="118.23"
        cy="179.2"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="193"
        cx="125.4"
        cy="167.68"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="194"
        cx="133.24"
        cy="156.59"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="195"
        cx="141.61"
        cy="145.99"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="196"
        cx="150.55"
        cy="135.81"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="197"
        cx="169.67"
        cy="117.37"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="198"
        cx="180.2"
        cy="108.75"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="199"
        cx="191.1"
        cy="100.77"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="200"
        cx="202.57"
        cy="93.32"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="201"
        cx="214.58"
        cy="86.45"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="202"
        cx="226.83"
        cy="80.32"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="203"
        cx="251.66"
        cy="70.39"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="204"
        cx="264.3"
        cy="66.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="205"
        cx="277.24"
        cy="63.25"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="206"
        cx="290.3"
        cy="60.73"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="207"
        cx="303.61"
        cy="58.86"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="208"
        cx="316.92"
        cy="57.88"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="209"
        cx="343.69"
        cy="57.88"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="210"
        cx="357.38"
        cy="58.96"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="211"
        cx="370.76"
        cy="60.81"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="212"
        cx="383.85"
        cy="63.26"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="213"
        cx="397.06"
        cy="66.65"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="214"
        cx="410.35"
        cy="70.88"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="215"
        cx="434.77"
        cy="80.7"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="216"
        cx="446.74"
        cy="86.77"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="217"
        cx="458.77"
        cy="93.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="218"
        cx="469.92"
        cy="100.97"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="219"
        cx="480.93"
        cy="108.98"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="220"
        cx="491.01"
        cy="117.14"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="221"
        cx="510.06"
        cy="135.73"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="222"
        cx="518.99"
        cy="145.85"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="223"
        cx="527.37"
        cy="156.6"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="224"
        cx="535.35"
        cy="167.82"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="225"
        cx="542.75"
        cy="179.41"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="226"
        cx="549.14"
        cy="191.25"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="227"
        cx="559.87"
        cy="215.43"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="228"
        cx="564.81"
        cy="229.79"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="229"
        cx="568.79"
        cy="244.01"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="230"
        cx="571.96"
        cy="258.84"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="231"
        cx="574.19"
        cy="273.64"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="232"
        cx="575.49"
        cy="288.1"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="233"
        cx="575.94"
        cy="303.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="234"
        cx="58.71"
        cy="316.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="235"
        cx="58.71"
        cy="300.41"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="236"
        cx="59.38"
        cy="283.97"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle data-seat="237" cx="61" cy="267.76" r="6" fill="#CFD8DC"></circle>
      <circle
        data-seat="238"
        cx="63.58"
        cy="252.01"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="239"
        cx="67.16"
        cy="236.32"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="240"
        cx="71.66"
        cy="220.43"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="241"
        cx="77.02"
        cy="205.01"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="242"
        cx="87.91"
        cy="180.42"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="243"
        cx="94.01"
        cy="169.07"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="244"
        cx="100.67"
        cy="157.97"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="245"
        cx="107.82"
        cy="147.24"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="246"
        cx="115.49"
        cy="136.84"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="247"
        cx="123.78"
        cy="126.67"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="248"
        cx="132.51"
        cy="116.93"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="249"
        cx="151.65"
        cy="98.49"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="250"
        cx="161.58"
        cy="90.27"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="251"
        cx="171.87"
        cy="82.55"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="252"
        cx="182.66"
        cy="75.19"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="253"
        cx="193.85"
        cy="68.28"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="254"
        cx="205.32"
        cy="61.84"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="255"
        cx="217.13"
        cy="56.12"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="256"
        cx="241.92"
        cy="46.16"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="257"
        cx="254.03"
        cy="42.27"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="258"
        cx="266.33"
        cy="39.07"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="259"
        cx="278.74"
        cy="36.34"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="260"
        cx="291.35"
        cy="34.15"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="261"
        cx="304.12"
        cy="32.64"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="262"
        cx="316.92"
        cy="31.8"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="263"
        cx="343.69"
        cy="31.8"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="264"
        cx="356.6"
        cy="32.72"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="265"
        cx="369.34"
        cy="34.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="266"
        cx="382.14"
        cy="36.35"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="267"
        cx="395.01"
        cy="39.15"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="268"
        cx="407.7"
        cy="42.55"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="269"
        cx="419.95"
        cy="46.59"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="270"
        cx="444.71"
        cy="56.63"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="271"
        cx="456.93"
        cy="62.49"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="272"
        cx="467.99"
        cy="68.83"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="273"
        cx="478.73"
        cy="75.48"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="274"
        cx="489.18"
        cy="82.57"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="275"
        cx="499.32"
        cy="90.34"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="276"
        cx="509.12"
        cy="98.5"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="277"
        cx="528.24"
        cy="116.95"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="278"
        cx="537"
        cy="126.56"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="279"
        cx="545.14"
        cy="136.63"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="280"
        cx="552.96"
        cy="147.02"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="281"
        cx="560.18"
        cy="158.02"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="282"
        cx="566.83"
        cy="169.33"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle data-seat="283" cx="573" cy="180.6" r="6" fill="#CFD8DC"></circle>
      <circle
        data-seat="284"
        cx="583.72"
        cy="204.84"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="285"
        cx="588.56"
        cy="218.43"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="286"
        cx="592.58"
        cy="231.85"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="287"
        cx="595.94"
        cy="245.67"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="288"
        cx="598.6"
        cy="259.7"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="289"
        cx="600.46"
        cy="273.88"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="290"
        cx="601.65"
        cy="288.25"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="291"
        cx="602.01"
        cy="303.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="292"
        cx="33.27"
        cy="284.46"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="293"
        cx="34.54"
        cy="269.16"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="294"
        cx="36.73"
        cy="253.73"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="295"
        cx="39.61"
        cy="238.8"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="296"
        cx="43.23"
        cy="223.86"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="297"
        cx="47.75"
        cy="209.17"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="298"
        cx="53.2"
        cy="194.24"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="299"
        cx="64.07"
        cy="169.79"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="300"
        cx="71.02"
        cy="156.72"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="301"
        cx="78.53"
        cy="144.19"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="302"
        cx="86.63"
        cy="132.03"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="303"
        cx="95.26"
        cy="120.39"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="304"
        cx="104.44"
        cy="109.15"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="305"
        cx="114.3"
        cy="98.24"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="306"
        cx="133.49"
        cy="79.64"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="307"
        cx="144.85"
        cy="70.2"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="308"
        cx="156.83"
        cy="61.13"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="309"
        cx="168.85"
        cy="52.89"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="310"
        cx="181.12"
        cy="45.39"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle data-seat="311" cx="194" cy="38.34" r="6" fill="#CFD8DC"></circle>
      <circle
        data-seat="312"
        cx="207.28"
        cy="31.9"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="313"
        cx="232.17"
        cy="21.94"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="314"
        cx="245.66"
        cy="17.26"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="315"
        cx="260.03"
        cy="13.54"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="316"
        cx="274.39"
        cy="10.49"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="317"
        cx="288.52"
        cy="8.24"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="318"
        cx="302.82"
        cy="6.43"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="319"
        cx="316.92"
        cy="5.57"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="320"
        cx="343.69"
        cy="5.57"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="321"
        cx="358.17"
        cy="6.63"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="322"
        cx="372.76"
        cy="8.38"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="323"
        cx="387.19"
        cy="10.78"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="324"
        cx="401.58"
        cy="13.93"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="325"
        cx="415.7"
        cy="17.69"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="326"
        cx="429.8"
        cy="22.23"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="327"
        cx="454.46"
        cy="32.25"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="328"
        cx="467.55"
        cy="38.69"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="329"
        cx="479.71"
        cy="45.44"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="330"
        cx="491.86"
        cy="52.81"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="331"
        cx="504.16"
        cy="61.27"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle data-seat="332" cx="516" cy="70.06" r="6" fill="#CFD8DC"></circle>
      <circle
        data-seat="333"
        cx="527.31"
        cy="79.74"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="334"
        cx="546.41"
        cy="98.11"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="335"
        cx="556.43"
        cy="109.15"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="336"
        cx="565.91"
        cy="120.62"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="337"
        cx="574.88"
        cy="132.84"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="338"
        cx="582.92"
        cy="145.05"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="339"
        cx="590.07"
        cy="157.26"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="340"
        cx="596.77"
        cy="170.04"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="341"
        cx="607.63"
        cy="194.39"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="342"
        cx="613.01"
        cy="209.45"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="343"
        cx="617.62"
        cy="225.18"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="344"
        cx="621.58"
        cy="240.82"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="345"
        cx="624.59"
        cy="256.69"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="346"
        cx="626.66"
        cy="272.63"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="347"
        cx="627.67"
        cy="288.1"
        r="6"
        fill="#CFD8DC"
      ></circle>
      <circle
        data-seat="348"
        cx="628.09"
        cy="303.08"
        r="6"
        fill="#CFD8DC"
      ></circle>
    </svg>
  );
});
